import { useFeatureAccessSettings } from '../featureAccessSettings';
import { useHasUserNetworkLeaders } from '../userNetworkLeaders';
import { useLoadAllLeaders, useUserNetworkLeadersListStatus } from '../userNetworkLeadersList';

import { useCanUserAccessLeadershipCornerWithoutLeaders } from './useCanUserAccessLeadershipCornerWithoutLeaders';

// Temporary fix, remove options when resolving this bug ticket:
// https://yammer.visualstudio.com/engineering/_workitems/edit/365714
interface UseCanUserAccessLeadershipCornerOptions {
  readonly deferApiCalls?: boolean;
}
type UseCanUserAccessLeadershipCorner = (options?: UseCanUserAccessLeadershipCornerOptions) => boolean;
export const useCanUserAccessLeadershipCorner: UseCanUserAccessLeadershipCorner = (options) => {
  useLoadAllLeaders({ leadersCount: 1, skipApiCall: options?.deferApiCalls });

  const featureAccessSettings = useFeatureAccessSettings();

  const hasUserNetworkLeaders = useHasUserNetworkLeaders();
  const canUserAccessLeadershipCornerWithoutLeaders = useCanUserAccessLeadershipCornerWithoutLeaders();
  const isUserNetworkLeadersListFulfilled = useUserNetworkLeadersListStatus() === 'fulfilled';

  if (isUserNetworkLeadersListFulfilled && !hasUserNetworkLeaders) {
    return canUserAccessLeadershipCornerWithoutLeaders;
  }

  return !!featureAccessSettings?.viewerCanAccessLeadershipCorner;
};
